import { Outlet, useNavigate } from 'react-router-dom'
import { AdminLayout } from '@/admin-design/_common'
import { LayoutDashboard, Target, TrendingUp, Shield, Settings, Newspaper, Activity, CalendarDays, Layers, Globe, BarChart3, BookOpen } from 'lucide-react'
import { api } from '@/api/client'
import KillSwitchBanner from './KillSwitchBanner'

const navItems = [
  { to: '/', label: 'Dashboard', end: true, icon: <LayoutDashboard size={14} aria-hidden="true" /> },
  { to: '/plan', label: 'Plan', icon: <Target size={14} aria-hidden="true" /> },
  { to: '/positions', label: 'Positions', icon: <TrendingUp size={14} aria-hidden="true" /> },
  { to: '/crypto-journal', label: 'Journal', icon: <BookOpen size={14} aria-hidden="true" /> },
  { to: '/news', label: 'News', icon: <Newspaper size={14} aria-hidden="true" /> },
  { to: '/clusters', label: 'Clusters', icon: <Layers size={14} aria-hidden="true" /> },
  { to: '/us-equity', label: 'US Equity', icon: <Globe size={14} aria-hidden="true" /> },
  { to: '/backtest', label: 'Backtest', icon: <BarChart3 size={14} aria-hidden="true" /> },
  { to: '/calendar', label: 'Calendar', icon: <CalendarDays size={14} aria-hidden="true" /> },
  { to: '/jobs', label: 'Jobs', icon: <Activity size={14} aria-hidden="true" /> },
  { to: '/guardrail', label: 'Guardrail', icon: <Shield size={14} aria-hidden="true" /> },
  { to: '/settings', label: 'Settings', icon: <Settings size={14} aria-hidden="true" /> },
]

export default function Layout() {
  const nav = useNavigate()
  const onLogout = async () => {
    try {
      await api.logout()
    } finally {
      nav('/login')
    }
  }
  return (
    <AdminLayout brand="Quant Trader" navItems={navItems} onLogout={onLogout}>
      <Outlet />
      <KillSwitchBanner />
    </AdminLayout>
  )
}
